import React from 'react';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

interface IProps {
	onSaveAndApplyOtherLocations?: () => void;
	onSaveLocalChanges?: () => void;
	onSave?: () => void;
	onCancel: () => void;
	isDisabledSave: boolean;
}

export const BtnBlock: React.FC<IProps> = ({
	onSaveAndApplyOtherLocations,
	onSaveLocalChanges,
	onSave,
	onCancel,
	isDisabledSave,
}) => {
	return (
		<div className={style.container} data-test="BtnBlock">
			<Button
				className={style.cancelBtn}
				theme="outlined"
				onClick={onCancel}
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				}
				data-test="cancelButton">
				<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
			</Button>
			{onSaveAndApplyOtherLocations && (
				<Button
					className={style.saveBtn}
					onClick={onSaveAndApplyOtherLocations}
					theme="primaryBlue"
					disabled={isDisabledSave}
					data-test="confirmButton">
					<Text
						translationNameSpace="form"
						translationKey="saveAndApplyToOtherLocationsButton"
						asFragment={true}
					/>
				</Button>
			)}
			{onSaveLocalChanges && (
				<Button
					className={style.saveBtn}
					onClick={onSaveLocalChanges}
					theme="primaryBlue"
					disabled={isDisabledSave}
					data-test="confirmButton">
					<Text translationNameSpace="form" translationKey="saveLocalChangesButton" asFragment={true} />
				</Button>
			)}
			{onSave && (
				<Button
					className={style.saveBtn}
					onClick={onSave}
					theme="primaryBlue"
					disabled={isDisabledSave}
					data-test="confirmButton">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			)}
		</div>
	);
};
